/* eslint-disable no-unused-expressions,global-require,react/destructuring-assignment,react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import { isDesktop } from '../../utils/mobileHelpers';
import { ImageManager } from '../common/ImageManager';
import styles from './index.styl';

const imageManagerStyles = {
  position: 'absolute',
  top: '8px',
  right: '8px',
};

@injectIntl
@CSSModules(styles, { allowMultiple: true })
export default class Banner extends PureComponent {
  static propTypes = {
    onImageRemove: PropTypes.func.isRequired,
    onImageCrop: PropTypes.func.isRequired,
    isModerator: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
  };

  state = {
    image: null,
    loaded: false,
  };

  componentWillMount() {
    this.preloadImage();
  }

  componentWillReceiveProps(nextProps) {
    const newImageValid =
      nextProps.image && !isEqual(this.props.image, nextProps.image);

    if (newImageValid) {
      this.preloadImage(nextProps);
    }
  }

  preloadImage(props) {
    const { image } = props || this.props;

    this.setState({
      image: null,
      loaded: false,
    });

    const urlImage = get(image, 'url');
    const urlThumb = get(image, 'small');

    const cb = isDesktop() ? () => this.preloadUrl(urlImage) : null;

    this.preloadUrl(urlThumb, cb);
  }

  preloadUrl(url, callback) {
    const img = new Image();

    if (!url) {
      return;
    }

    img.onload = () => {
      const isNeededImage = this.isAppropriateImage(url);

      isNeededImage &&
        this.setState(
          {
            image: url,
            loaded: !callback,
          },
          callback,
        );
    };

    img.src = url;
  }

  isAppropriateImage(url) {
    const { image } = this.props;

    const oUrl = get(image, 'url');
    const sUrl = get(image, 'small');

    return [oUrl, sUrl].includes(url);
  }

  render() {
    const {
      intl: { formatMessage },
      onImageRemove,
      onImageCrop,
      isModerator,
    } = this.props;
    const { image, loaded } = this.state;

    const defaultBanner = `url('${require(`../../assets/images/community-wallpaper.png`)}')`;
    const backgroundImage = image ? `url('${image}')` : defaultBanner;

    return (
      <div
        styleName={classNames('banner', {
          'banner--blurred': image && !loaded,
        })}
        style={{ backgroundImage }}
      >
        <ImageManager
          removeTitle={formatMessage({ id: 'community.banner.removeTitle' })}
          cropTitle={formatMessage({ id: 'community.banner.cropTitle' })}
          cropTip={formatMessage({ id: 'community.banner.cropTip' })}
          onImageRemove={onImageRemove}
          onImageCrop={onImageCrop}
          hidden={!isModerator}
          style={imageManagerStyles}
          aspectRatio={4 / 1}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/Banner.jsx